import React from "react";
import { Outlet } from "react-router-dom";

export default function LayoutNew() {
  return (
    <div className="min-h-screen bg-[#f7f8fb]">
      <Outlet />
    </div>
  );
}
